<template>
  <div class="index">
    <!--头部-->
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <jm-tableList :url="`/index/Statistics/getPraiseStudent/teacherid/${$route.params.teacherid}`">
            <el-table-column
              slot="nickname"
              label="姓名">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'evaluation', params: { teacherid: scope.row.teacherid, crmid: scope.row.crmid } }">
                  {{ scope.row.nickname }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              slot="professional_degrees"
              label="专业度">
              <template slot-scope="scope">
                <el-rate
                  v-model="scope.row.professional_degrees"
                  disabled
                  text-color="#ff9900"/>
              </template>
            </el-table-column>
            <el-table-column
              slot="response_time"
              label="响应时间">
              <template slot-scope="scope">
                <el-rate
                  v-model="scope.row.response_time"
                  disabled
                  text-color="#ff9900"/>
              </template>
            </el-table-column>
            <el-table-column
              slot="service_attitude"
              label="服务态度">
              <template slot-scope="scope">
                <el-rate
                  v-model="scope.row.service_attitude"
                  disabled
                  text-color="#ff9900"/>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <!--页脚-->
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      searchData: {}
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {
  },
  methods: {
  },
  watch: {
  },
};
</script>
<style scoped>
  .basic-padding {
    padding: 20px 10px;
    text-align: left;
  }
</style>
